let Products = {
    init: function () {
        this.bind();
    },

    bind: function () {
        this.duplicate();
        this.addForm();
        this.editForm();
        this.form();
        this.delete();
        this.schedule();
        this.checkGroupPricing();
        this.tagsAutocomplete();
    },

    addForm: function () {
        let _this = this;

        const productForm = $('#productForm');

        if (productForm.length) {
            $(document).on('click', '.add-product', () => {
                productForm.find('#productId').val('');
                productForm.find('#productActiveCampaignTagId').val('');
                productForm.find('#productType').val('');
                productForm.find('#calendarColor').val('');
                productForm.find('#productDisplayInStore').iCheck('uncheck');
                productForm.find('#productDisplayInEventsCalendar').iCheck('uncheck');
                productForm.find('#productSoldOut').iCheck('uncheck');
                productForm.find('#productRestrictPurchase').iCheck('uncheck');
                productForm.find('#productDiscountFor5').iCheck('uncheck');
                productForm.find('#productManualTicketsSold').val(0);
                productForm.find('[id^=plan_]').iCheck('uncheck');
                $('#eventSchedule').empty();
                productForm.resetForm();
                $('#productType').change();
                $('#calendarColor').change();
            });
            let submitBtn = Ladda.create(productForm.find('[type=submit]')[0]);
            // let dateFormat = 'D/MM/Y hh:mm:ss A';

            /*let startDate = $('.datetimepicker').datetimepicker({
                format: dateFormat,
            });
            let endDate = $('#eventEndDate').datetimepicker({
                format: dateFormat,
            });*/

            productForm.ajaxForm({
                beforeSubmit: function () {
                    $('.form-group').removeClass('has-error');
                    submitBtn.start();
                },
                success: function (response) {
                    if (response.success) {
                        window.location.reload();
                    } else {
                        submitBtn.stop();
                        toastr.error(response.message);
                    }
                },
                error: function (err) {
                    submitBtn.stop();

                    let error = err.responseJSON;

                    if (error.errors) {
                        toastr.error(Object.values(error.errors).join('<br>')).css("width", "500px");
                        Object.keys(error.errors).forEach(field => {
                            $('[name=' + field + ']').closest('.form-group').addClass('has-error');
                        });
                    } else {
                        toastr.error(error.message);
                    }

                }
            });
        }
    },

    editForm: function () {
        let _this = this;

        const productForm = $('#productForm');
        const productModal = $('#productModal');

        $('.edit-product').click(function () {
            const id = $(this).data('id');
            const row = $(this).closest('tr');

            $.get('/products/' + id + '/json', response => {
                if (response.success) {
                    const product = response.data;

                    productForm.find('#productTitle').val(product.title);
                    productForm.find('#productSubtitle').val(product.subtitle);
                    productForm.find('#productType').val(product.product_type);
                    productForm.find('#calendarColor').val(product.calendar_color);
                    productForm.find('#eventSalesPage').val(product.event_sales_page);
                    productForm.find('#productPromoText').val(product.promo_text);
                    productForm.find('#productCode').val(product.product_code);
                    productForm.find('#eventAddress').val(product.event_address);
                    productForm.find('#eventSuburb').val(product.event_suburb);
                    productForm.find('#eventState').val(product.event_state);
                    productForm.find('#eventPostCode').val(product.event_postcode);
                    productForm.find('#eventCountry').val(product.event_country);
                    productForm.find('#eventCity').val(product.location_alt_title);
                    productForm.find('#productTabLine1').val(product.tab_line_1);
                    productForm.find('#productTabLine2').val(product.tab_line_2);
                    productForm.find('#productExternalSalesPageUrl').val(product.external_url);
                    productForm.find('#productQuantity').val(product.quantity);
                    productForm.find('#productCurrency').val(product.currency);
                    productForm.find('#productPrice').val(product.price / 100);
                    productForm.find('#productAdditionalTicketPrice').val(product.additional_ticket_price / 100);
                    productForm.find('#productManualTicketsSold').val(product.manual_tickets_sold);
                    productForm.find('#productSimpleDate').val(product.simple_date);
                    productForm.find('#productSimpleTime').val(product.simple_time);
                    productForm.find('#productWhenDescription').val(product.when_description);
                    productForm.find('#productTimeDescription').val(product.time_description);
                    productForm.find('#productVenueDescription').val(product.venue_description);
                    productForm.find('#productTicketsDescription').val(product.tickets_description);

                    if (product.tag) {
                        let option = new Option(product.tag.name, product.tag.id, true, true);
                        productForm.find('#productActiveCampaignTagId').append(option).trigger('change');
                    } else {
                        productForm.find('#productActiveCampaignTagId').val(null).trigger('change');
                    }
                    // productForm.find('#productActiveCampaignTagId').val(product.ac_tag_id);

                    // productForm.find('#productDisplayInStore').prop('checked', product.display_in_store === 1);
                    productForm.find('#productDisplayInStore').iCheck(product.display_in_store === true ? 'check' : 'uncheck');
                    productForm.find('#productDisplayInEventsCalendar').iCheck(product.display_in_events_calendar === true ? 'check' : 'uncheck');
                    productForm.find('#productSoldOut').iCheck(product.sold_out === true ? 'check' : 'uncheck');
                    productForm.find('#productRestrictPurchase').iCheck(product.restrict_purchase === true ? 'check' : 'uncheck');
                    productForm.find('#productDiscountFor5').iCheck(product.discount_for_5_or_more === true ? 'check' : 'uncheck');
                    productForm.find('#productGroupPricing').iCheck(product.group_pricing === true ? 'check' : 'uncheck');
                    productForm.find('#productGroupCount').val(product.group_count);
                    productForm.find('#productPermissionLevel').val(product.permission_level);
                    productForm.find('#productAccessStartDate').val(product.access_start_date_formatted);
                    productForm.find('#productAccessEndDate').val(product.access_end_date_formatted);
                    productForm.find('#productAccessCode').val(product.access_code);
                    _this.checkGroupPricing();

                    productForm.find('[id^=plan_]').iCheck('uncheck');

                    if (product.plans && product.plans.length) {
                        product.plans.forEach(plan => {
                            productForm.find('#plan_' + plan).iCheck('check');
                        });
                    }

                    //productForm.find('#eventLocation').val(product.location_alt_title);

                    $('#eventSchedule').empty();

                    if (product.schedule.length) {
                        $.each(product.schedule, (index, schedule) => {
                            $('#eventLocation').val(schedule.location_address);
                            let startDate = moment(schedule.start_date).format('DD/MM/YYYY hh:mm:ss A');
                            let endDate = moment(schedule.end_date).format('DD/MM/YYYY hh:mm:ss A');


                            let html = '<div class="date-group mt-2 row">\n' +
                                '                                <div class="form-group col-sm-6">\n' +
                                '                                    <label>Start Date</label>\n' +
                                '                                    <input type="text" class="form-control datetimepicker" name="schedule[' + schedule.id + '][start_date]" value="' + startDate + '" placeholder="Start Date" autocomplete="new-password">\n' +
                                '                                </div>\n' +
                                '                                <div class="form-group col-sm-6">\n' +
                                '                                    <label>End Date</label>\n' +
                                '                                    <input type="text" class="form-control datetimepicker" name="schedule[' + schedule.id + '][end_date]" value="' + endDate + '" placeholder="End Date" autocomplete="new-password">\n' +
                                '                                </div>\n' +
                                '                                <div class="form-group col-sm-12">\n' +
                                '                                    <input type="hidden" name="schedule[' + schedule.id + '][id]" value="' + schedule.id + '">\n' +
                                '                                    <button type="button" class="btn btn-danger remove-schedule">Remove</button>\n' +
                                '                                </div>\n' +
                                '                            </div>';
                            $('#eventSchedule').append(html);
                        });

                        Init.datetimepicker();
                    }


                    productForm.find('#productId').val(product.id);
                    productForm.find('#productType').change();
                    productForm.find('#calendarColor').change();
                    productForm.find('#productActiveCampaignTagId').change();
                    productModal.modal('show');
                }
            });
        });
    },

    delete: function () {
        $('.delete-product').click(function () {
            let id = $(this).data('id');
            let row = $(this).closest('tr');

            swal({
                title: "Are you sure?",
                text: "Your will not be able to recover this record!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: "Yes, delete it!"
            }).then((result) => {
                if (result.value) {
                    $.post('/products/' + id,
                        {
                            _method: 'delete'
                        },
                        (result) => {
                            if (result.success) {
                                let table = row.closest('table').DataTable();
                                table.row(row).remove().draw();
                                swal(
                                    'Deleted!',
                                    'Record has been deleted.',
                                    'success'
                                ).then((result) => {

                                });
                            }
                        });
                }
            });
        });
    },

    duplicate: function () {
        $('.duplicate-product').click(function () {
            let id = $(this).data('id');
            let row = $(this).closest('tr');

            swal({
                title: "Are you sure?",
                text: "Do you want to duplicate this record?",
                type: "info",
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: "Yes!"
            }).then((result) => {
                if (result.value) {
                    $.post('/products/' + id + '/duplicate',
                        {},
                        (result) => {
                            if (result.success) {
                                window.location.reload();
                            }
                        });
                }
            });
        });
    },

    form: function () {
        let _this = this;
        const productForm = $('#productForm');

        $(document).on('change', '#productType', function (e) {
            const product = $(this).val();

            if (product === 'event') {
                productForm.find('.event').show();
            } else {
                productForm.find('.event').hide();
            }
        });

        $('#products').on('draw.dt', function () {
            _this.editForm();
            _this.delete();
            _this.duplicate();
        });

        $('#productGroupPricing').on('ifChanged', function(event) {
            _this.checkGroupPricing();
        });
    },

    schedule: function () {
        $(document).on('click', '.add-schedule', () => {
            const container = $('#eventSchedule');
            const count = $('.date-group').length + 1;
            const html = '<div class="date-group mt-2 row">\n' +
                '                                <div class="form-group col-sm-6">\n' +
                '                                    <label>Start Date</label>\n' +
                '                                    <input type="text" class="form-control datetimepicker" name="schedule[' + count + '][start_date]" value="" placeholder="Start Date" autocomplete="new-password">\n' +
                '                                </div>\n' +
                '                                <div class="form-group col-sm-6">\n' +
                '                                    <label>End Date</label>\n' +
                '                                    <input type="text" class="form-control datetimepicker" name="schedule[' + count + '][end_date]" value="" placeholder="End Date" autocomplete="new-password">\n' +
                '                                </div>\n' +
                '                                <div class="form-group col-sm-12">\n' +
                '                                    <button type="button" class="btn btn-danger remove-schedule">Remove</button>\n' +
                '                                </div>\n' +
                '                            </div>';

            container.append(html);
            Init.datetimepicker();
        });

        $(document).on('click', '.remove-schedule', function () {
            const container = $(this).closest('.date-group');
            container.remove();
        });
    },

    checkGroupPricing: function() {
        if ($('#productGroupPricing').prop('checked')) {
            $('#productGroupCount').closest('.form-group').show();
            $('#productAdditionalTicketPrice').closest('.form-group').show();
            $('#paymentPlansContainer').hide();
            $('#paymentPlansContainer [type=checkbox]').each((index, elem) => {
                $(elem).iCheck('uncheck');
            });
        } else {
            $('#productGroupCount').closest('.form-group').hide();
            $('#productAdditionalTicketPrice').closest('.form-group').hide();
            $('#paymentPlansContainer').show();
        }
    },

    tagsAutocomplete() {
        const elem = $('#productActiveCampaignTagId')
        elem.select2({
            ajax: {
                url: '/products/tags/autocomplete',
                dataType: 'json',
                processResults: function (data) {
                    return {
                        results: data.items
                    };
                },
            },

            placeholder: 'Select Tag ...',
            minimumInputLength: 2,
        });
    },

    _getDate: function (element, dateFormat) {
        let date;
        try {
            date = $.datepicker.parseDate(dateFormat, element.value);
        } catch (error) {
            date = null;
        }

        return date;
    }
};

$().ready(function () {
    window.Products = Products;
    window.Products.init();
});
